import { useState, useEffect } from 'react';

import { Tracking } from '@nerdwallet/nw-client-lib';

import styles from '../control-panel.module.less';

type useControlPanelToggleReturn = {
  isOpen: boolean;
  toggleControlPanel: (e: any) => void;
};

type useControlPanelToggleProps = {
  enableTracking: boolean;
  formName?: string;
  fieldName?: string;
};
const useControlPanelToggle = ({
  enableTracking,
  formName,
  fieldName,
}: useControlPanelToggleProps): useControlPanelToggleReturn => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(
    () => {
      if (enableTracking) {
        const { formOpen, formCancel } = Tracking;
        const payload = {
          formName,
          fieldName,
        };
        if (isOpen) {
          document?.body?.classList?.add(styles.bodyOverflowHidden);
          formOpen(payload);
        } else {
          document?.body?.classList?.remove(styles.bodyOverflowHidden);
          formCancel(payload);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isOpen]
  );

  const toggleControlPanel = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    setIsOpen((prevOpen) => !prevOpen);
  };

  return { isOpen, toggleControlPanel };
};

export default useControlPanelToggle;
